import { useState } from 'react';
import {
  Card,
  Stack,
  Avatar,
  IconButton,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  Chip,
  CircularProgress,
  Paper,
  Box,
  Collapse
} from '@mui/material';
import { Icon } from '@iconify/react';
import arrowIosForwardFill from '@iconify/icons-eva/arrow-ios-forward-fill';
import arrowIosDownwardFill from '@iconify/icons-eva/arrow-ios-downward-fill';
import { useParams } from 'react-router-dom';
import DriveIcon from '@mui/icons-material/DriveEta';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Page from '../components/Page';
import { ProfileCommercialForm } from '../components/_dashboard/user';

export default function UpdateCommercial() {
  return (
    <Page title="User  ">
      <Container>
        <Card>
          <ProfileCommercialForm />
        </Card>
      </Container>
    </Page>
  );
}
